import Layout from "./Layout.jsx";
import NewQuotation from "../components/NewQuotation.jsx";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getMe } from "../features/authSlice.js";

const AddQuotation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);

  return (
    <>
      {user && (
        <Layout>
          <NewQuotation></NewQuotation>
        </Layout>
      )}
      {/* Add a loader or handle unauthorized access */}
    </>
  );
};

export default AddQuotation;
